import './style.scss';

export function second_cta_block() {
    const block = document.querySelector('.second_cta_block');
    if (!block) return;
}

